import type { BaseModel, Brand, DaysWeek } from "./application";
import type { People } from "./people";

export interface Contract extends BaseModel {
  status: ContractStatus;
  start_date: string;
  due_date: string;
  value: number;
  type_value: ContractTypeValue;
  title: string;
  description: string;
  user_owner: string;
  payment_day: DaysWeek;
  payment_first_installment: number;
  payment_frequency: ContractPaymentFrequency;
  payment_installment: number;
  payment_start_date: string;
  payment_end_date: string;
  payment_type: ContractPaymentType;
  people?: People[];
  notes?: ContractNote[];
  docs?: ContractDoc[];
  // payments?: ContractPayment[];
  tags?: ContractTag[];
  brand: Brand;
  // contract_nature: ContractNature;
  signature_date?: string;
  execution_date?: string;
  termination_date?: string;
  termination_for_cause_days: number;
  termination_for_convenience_days: number;
  renewal_type: ContractRenewType;
  renewal_grace_period_days: number;
  renewal_notice_period_days: number;
}

export enum ContractRenewType {
  INDEFINITE_DURATION = 'indefinite_duration',
  AUTOMATIC_RENEWAL = 'automatic_renewal',
  RENEWAL_OPTION = 'renewal_option',
  FIXED_TERM = 'fixed_term'
}

export enum ContractStatus {
  ACTIVE = 'active',
  TERMINATED = 'terminated',
  COMPLETED = 'completed'
}

export enum ContractTypeValue {
  MONETARY = 'monetary',
  PERCENTAGE = 'percentage'
}

export enum ContractPaymentType {
  LOOSE = 'LOOSE',
  RECURRENT = 'RECURRENT',
  MUTUAL = 'MUTUAL'
}

export enum ContractPaymentFrequency {
  WEEKLY = 'WEEKLY',
  FORTWEEKLY = 'FORTWEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}


export interface ContractDoc {
  contract_id: string;
  description: string;
  doc: string;
}

export interface ContractTag {
  name: string;
  bg_color: string;
  text_color: string;
}

export interface ContractNote extends BaseModel {
  user_id: number;
  contract_id: string;
  note: string;
}
